import moment from 'moment';
import lodash from 'lodash';

function deepMerge(source, update, updateFunction) {
    var result = {};

    updateFunction = updateFunction || ((oldValue, newValue) => newValue)

    lodash.map(source, (oldValue, prop) => {
        if (update.hasOwnProperty(prop)) {
            let newValue = update[prop];

            if (lodash.isObject(oldValue) && lodash.isObject(newValue)) {
                result[prop] = deepMerge(oldValue, newValue)
            } else {
                result[prop] = updateFunction(oldValue, newValue);
            }
        } else {
            result[prop] = oldValue;
        }
    });

    // garante que as novas propriedades irao ser injetadas no objeto
    lodash.map(update, (value, prop) => {
        if (!result.hasOwnProperty(prop)) {
            result[prop] = lodash.isObject(value) ? deepMerge({}, value) : value;
        }
    });

    return result;
}

export default {
    moment,
    lodash,
    deepMerge
}